export default function Logo({ className = "h-8 w-auto", withWordmark = true }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-nav="true">
      <svg
        viewBox="0 0 64 64"
        aria-hidden="true"
        className="h-8 w-8 shrink-0"
      >
        <g fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="square">
          <rect x="16" y="20" width="10" height="28" />
          <rect x="38" y="14" width="10" height="34" />
          <path d="M11 20 Q32 4 53 14" />
        </g>
        <g fill="currentColor">
          <circle cx="19" cy="54" r="1.6" />
          <circle cx="25" cy="54" r="1.6" />
          <circle cx="31" cy="54" r="1.6" />
          <circle cx="37" cy="54" r="1.6" />
          <circle cx="43" cy="54" r="1.6" />
        </g>
      </svg>
      {withWordmark && (
        <span
          className="font-display text-xl leading-none tracking-[0.02em]"
          style={{ letterSpacing: "0.02em" }}
        >
          arqovena
        </span>
      )}
    </div>
  );
}
